module.exports = __webpack_public_path__ + "img/menu-user.3dc7ef68.svg";